export const FETCH_ACTIVE_SUBSCRIPTION_INIT = "FETCH_ACTIVE_SUBSCRIPTIONS_INIT";
export const FETCH_ACTIVE_SUBSCRIPTION_SUCCESS =
  "FETCH_ACTIVE_SUBSCRIPTIONS_SUCCESS";
export const FETCH_ACTIVE_SUBSCRIPTION_FAIL =
  "FETCH_ACTIVE_SUBSCRIPTIONS_FAILURE";
export const UPDATE_ACTIVE_SUBSCRIPTION = "UPDATE_ACTIVE_SUBSCRIPTION";
export const ADD_ACTIVE_WEEKLY_COACHING_SUBSCRIPTION =
  "ADD_ACTIVE_WEEKLY_COACHING_SUBSCRIPTION";
